document.addEventListener('DOMContentLoaded', function () {
    const enhancedSearchbar = document.querySelector('.enhanced-searchbar');
    
    if (!enhancedSearchbar) {
      return;
    }
    
    const toggleButton = enhancedSearchbar.querySelector('.search-toggle-button');
    const searchHeaderContainer = enhancedSearchbar.querySelector('.searchbar-header-container');
    
    if (!toggleButton || !searchHeaderContainer) {
      return;
    }
    
    // Toggle searchbar on button click
    toggleButton.addEventListener('click', function (e) {
      e.preventDefault();
      searchHeaderContainer.classList.toggle('active');
    });

    // Close searchbar when clicking outside
    document.addEventListener('click', function (e) {
      if (searchHeaderContainer.classList.contains('active') && 
          !enhancedSearchbar.contains(e.target)) {
        searchHeaderContainer.classList.remove('active');
      }
    });
  });